/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Inventory_Reservations_CountInputs */

const en_inventory_reservations_count = /** @type {(inputs: Inventory_Reservations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} reservations)`)
};

const es_inventory_reservations_count = /** @type {(inputs: Inventory_Reservations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} reservas)`)
};

/**
* | output |
* | --- |
* | "({count} reservations)" |
*
* @param {Inventory_Reservations_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_reservations_count = /** @type {((inputs: Inventory_Reservations_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Reservations_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_reservations_count(inputs)
	return es_inventory_reservations_count(inputs)
});